import React, {ReactElement} from "react"
import {observer} from "mobx-react-lite"
import {Button} from "antd"
import {useStore} from "@ui/stores"
import {t} from "@ui/common/intl"
import PlayIcon from "@ui/icons/common/Play"
import {TrackPage, TTrackPageProps} from "./"

const Start = ({goto, close}: TTrackPageProps): ReactElement => {
	const {track, settings} = useStore()

	const handleStart = () => {
		track.switchRecording()
    if (settings.isMobile) goto(TrackPage.Record)
    else {
      close()
      goto(TrackPage.List)
    }
	}

	return (
		<div className="start">
			<Button className="button-primary" icon={<PlayIcon />} onClick={handleStart}>
				{t("button.start")}
			</Button>
			<Button className="cancel button-regular" onClick={() => goto(TrackPage.List)}>
				{t("button.cancel")}
			</Button>
		</div>
	)
}

export default observer(Start)
